import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import query from 'query-string';
import CustomCard from '../../components/atoms/CustomCard';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../utils/apiClient';
import DynamicForm from './form';
import FormHeader from '../../components/atoms/FormHeader';
import { Alert, message, Spin } from 'antd';
import './styles.scss';
import QuotationForm from './quotationForm';
import CustomPopup from '../../components/atoms/CustomPopup';
import successIcon from '../../assets/images/success.png';
import failureIcon from '../../assets/images/failure.png';
import { HandleServerError } from '../../utils/serverErrorHandler';
import { isArray, isEmpty } from 'lodash';
import {prefilledFormValidation} from '../../constants/enums'
const QuestionForm = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [leadQualified, setLeadQualified] = useState(false);
  const [leadQualificationText,setLeadQualificationText] = useState('')
  const [showQuotationForm, setShowQuotationForm] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [meeting, setMeetingDetails] = useState({});
  const [dynamicFormDetails, setDynamicFormDetails] = useState({});
  const [formDetails, setFormDetails] = useState(location.state && location.state.topicDetails ? location.state.topicDetails : {});
  const [crnDetails, setCrnDetails] = useState({});
  const [questions, setQuestions] = useState([]);
  const [isleadstatus, setisLeadstatus] = useState(false);
  const [leadStatus, setLeadStatus] = useState(null); // "qualified" | "unqualified" | null
  const [params, setParams] = useState({});
  const [routeState, setRouteState] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false)
  const [isCommercial, setIsCommercial] = useState(false)
  useEffect(() => {
    if (!params && !routeState) {
      window.location.reload();
    }
  }, []);
  useEffect(() => {
    setParams(query.parse(location.search));
  }, [location.search]);
  useEffect(() => {
    setRouteState(location.state);
  }, [location.state]);

  useEffect(() => {
    if (routeState?.topicDetails) {
      setFormDetails(routeState?.topicDetails);
    }
  }, [routeState?.topicDetails]);
  // Fetches meeting details only (used after form submit to refresh meeting state)
  const getMeetingDetails = () => {
    let url = `/spinozaService/api/spinoza/v1/meetings/${params.meetingId}`
    if(params.crnId){
      url += `/${params.crnId}`
    }
    api
      .get(url, {}, {
        Authorization: `Bearer ${params.token}`
      })
      .then((res) => {
        setMeetingDetails(res.data.responseData);
      })
      .catch((error) => {
        HandleServerError(error)
      });
  };

  // Fetches both meeting details + form questions in parallel, then applies
  // all state updates in one batch to avoid cascading re-renders on load.
  const fetchInitialData = () => {
    if (routeState && routeState.quotationForm) {
      setShowQuotationForm(true);
      return;
    }

    const meetingUrl = `/spinozaService/api/spinoza/v1/meetings/${params.meetingId}${params.crnId ? `/${params.crnId}` : ''}`;
    const authHeader = { Authorization: `Bearer ${params.token}` };

    setLoading(true);
    Promise.all([
      api.get(meetingUrl, {}, authHeader),
      api.post(
        '/spinozaService/api/v1/osMeeting/topic',
        {},
        { topicId: params?.formId, crnId: params?.crnId, meetingId: params?.meetingId },
        authHeader
      ),
    ])
      .then(([meetingRes, topicRes]) => {
        // ── Meeting data ──
        const meetingData = meetingRes.data.responseData;

        // ── Questions + CRN meta ──
        const rawQuestions = topicRes.data.responseData.osMeetingQuestionList || [];
        const respMeta = topicRes.data.responseData || {};
        const isCommercial = respMeta.crnDetail?.constructionType === 'commercial';
        const isnewCommercial = respMeta.crnDetail?.newCommercialFlow === true;

        const hasUnqualified = rawQuestions.some(q =>
          Array.isArray(q.options) && q.options.some(opt =>
            opt?.uniqueId === 'MEETING_UNQUALIFIED' ||
            opt?.uniqueId === 'FOLLOW_UP_FUTURE_PIPELINE_OS'
          )
        );
        const futurePipeline = rawQuestions.some(q =>
          Array.isArray(q.options) && q.options.some(opt =>
            opt?.uniqueId === 'FOLLOW_UP_FUTURE_PIPELINE_OS'
          )
        );
        const taskEndQuestion = rawQuestions.find(q => q.serverValue === 'taskEndDate');
        if (taskEndQuestion && hasUnqualified && !futurePipeline) {
          taskEndQuestion.isMandatory = false;
        }

        const isFuturePipeline = typeof respMeta.isFuturePipeline === 'boolean'
          ? respMeta.isFuturePipeline
          : meetingData?.isFuturePipeline;
        const isLeadDead = typeof respMeta.isLeadDead === 'boolean'
          ? respMeta.isLeadDead
          : meetingData?.isLeadDead;

        const newLeadStatus =
          isLeadDead === true || isFuturePipeline === true || hasUnqualified
            ? 'Unqualified'
            : isCommercial ? 'Qualified' : null;

        // ── Single batched state update — one re-render instead of many ──
        setMeetingDetails(meetingData);
        setIsCommercial(isCommercial);
        setisLeadstatus(isCommercial && isnewCommercial && (hasUnqualified || !!taskEndQuestion));
        setLeadStatus(newLeadStatus);
        setQuestions(rawQuestions);
        setCrnDetails(respMeta.crnDetail || {});
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        HandleServerError(e);
      });
  };

  const moveNext = () => {
    setLoading(true);
    if (params.formId === '6363a5b183d40f070eab79d3') {
      navigate(`/?meetingId=${meeting.meetingId}&token=${params.token}&latitude=${params.latitude}&longitude=${params.longitude}`)
    } else {
      setQuestions([]);
      setLoading(true);
      let nextOptionForm = routeState.topicsList.filter((i, v) => i.id === formDetails.nextFormId) && routeState.topicsList.filter((i, v) => i.id === formDetails.nextFormId).length !== 0 ? routeState.topicsList.filter((i, v) => i.id === formDetails.nextFormId)[0] : {};
      if (!formDetails?.nextFormId || isEmpty(nextOptionForm)) {
        navigate(`/?meetingId=${meeting?.meetingId}&token=${params?.token}&latitude=${params?.latitude}&longitude=${params?.longitude}`);
        return;
      }
      navigate(`/form${(location.search).replace(`&formId=${params.formId}`, `&formId=${formDetails.nextFormId}`).replace(`&crnId=${params.crnId}`, `&crnId=${params.crnId}`)}`, {
        state: {
          topicDetails: nextOptionForm,
          initialForm: false,
          topicsList: routeState.topicsList,
          userDetails: {
            ...routeState.userDetails,
          }
        }
      });
    }
  }

  useEffect(() => {
    if (params.formId && params.crnId) {
      fetchInitialData();
    } else if (!params.formId && params.meetingId){
        getMeetingDetails();
    }
  }, [params.formId, params.crnId, params.meetingId]);

  const onSuccess = (text) => {
    message.success(text);
  };

  const onError = (text) => {
    messageApi.open({
      type: 'error',
      content: text,
      icon: () => (<></>),
      className: 'custom-error-message',
      style: {
        marginTop: '90%'
      },
    });
  };

  const onFormSubmit = (payload) => {
    const nextStepPayload = formDetails?.sendExtraInPayload ? {
      srUniqueId: params?.crnId ?? meeting?.crnId,
      assignedTo: routeState?.userDetails?.employeeUserId,
    } : {};

    console.log("payload", payload)
    let baseUrl = `/spinozaService${formDetails.endpoint.replace('${id}', params.meetingId)}`;
    api.put(baseUrl, {}, {
      ...payload,
      ...nextStepPayload,
      crnId: params.crnId,
      geoTracking: {
        latitude: params.latitude,
        longitude: params.longitude,
      },
    }, {
      Authorization: `Bearer ${params.token}`
    }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "SUCCESS") {
          getMeetingDetails();
          setSubmitLoading(false)
          message.success('Data saved successfully!');
          if(res.data.responseData.shouldShowPopUp){
            setLeadQualified(res.data.responseData.leadQualified);
            setLeadQualificationText(res.data.responseData.leadQualificationValue)
            setPopupVisible(true);
            return;
          } else if (params.formId === '6363a5b183d40f070eab79d3') {
            navigate(`/?meetingId=${meeting.meetingId}&token=${params.token}&latitude=${params.latitude}&longitude=${params.longitude}`)
          } else {
            moveNext();
          }
        } else {
          setSubmitLoading(false)
          message.error(res.data.errorMsg)
          onError(res.data.errorMsg);
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'error',
            message: 'api unauthorized failure'
          }))
        }
      } else {
        onError("Something went wrong");
      }
    })
      .catch((e) => {
        HandleServerError(e)
      })
      .finally((res)=>{
        sessionStorage.removeItem('isSubmitted');
      })
  }
  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(false)
    }
  }, [window && window.ReactNativeWebView]);

  useEffect(() => {
    setDynamicFormDetails(meeting[`${formDetails.serverValue}`] || {});
  }, [meeting, formDetails.serverValue, params.formId])

console.log("form data:", formDetails);
    console.log("form data1:",  meeting);
  console.log( "check"+ isCommercial + " "+ formDetails?.sendExtraInPayload + " "+ !!meeting?.isNextActionSubmitted);

const formattedText = leadQualificationText.split('\n').map((line, index) => (
  <React.Fragment key={index}>
      {line}
      <br />
  </React.Fragment>
));
  return (
    <>
      <div>
        <FormHeader headerTitle={formDetails.description} headerLeftClick={() => {
          navigate(-1);
        }} />
        <Spin spinning={loading}>
          <CustomCard>
            <>
              {!showQuotationForm && !isEmpty(crnDetails) && (prefilledFormValidation.includes(formDetails.serverValue) ? true : !isEmpty(dynamicFormDetails)) && (dynamicFormDetails) && questions && questions.length !== 0 && (
                <>
                {isleadstatus && (
                  <div style={{ background: '#fff4f4', color: '#b00020', padding: '8px', borderRadius: 4, marginBottom: 12, textAlign: 'center', fontWeight: 600 }}>
                    Status of the Lead: {leadStatus}
                  </div>
                )}
                <DynamicForm
                  formName={`${formDetails.serverValue}_form`}
                  initialForm={routeState.initialForm}
                  formDetails={{
                    ...dynamicFormDetails,
                    ...crnDetails,
                  }}
                  meeting={meeting}
                  disableForm={meeting.isFormDisabled}
                  onBack={() => {
                    setQuestions([]);
                    setLoading(true);
                    navigate(-1);
                  }}
                  formId={params.formId}
                  moveNext={moveNext}
                  apiToken={params.token}
                  questions={questions}
                  onSubmit={onFormSubmit}
                  onSuccess={onSuccess}
                  onError={onError}
                  userDetails={{
                    token: params.token,
                    currentLocation: {
                      latitude: params.latitude,
                      longitude: params.longitude,
                    }
                  }}
                  submitLoading={submitLoading}
                  setSubmitLoading={setSubmitLoading}
                  isCommercial={isCommercial}
                 isNextActionSubmitted={
  isCommercial &&
  formDetails?.sendExtraInPayload &&
  !!meeting?.isNextActionSubmitted
}
                />
                </>
              )}
              {showQuotationForm && (
                <QuotationForm
                  meeting={meeting}
                  userDetails={{
                    token: params.token,
                    ...routeState.userDetails,
                  }}
                  setLoading={setLoading}
                  onSuccess={onSuccess}
                  onError={onError}
                  onBack={() => navigate(-1)}
                />
              )}
            </>
          </CustomCard>
        </Spin>
      </div>
      <CustomPopup
        visible={popupVisible}
        onConfirm={() => {
          setQuestions([]);
          let nextOptionForm = routeState.topicsList.filter((i, v) => i.id === formDetails.nextFormId) && routeState.topicsList.filter((i, v) => i.id === formDetails.nextFormId).length !== 0 ? routeState.topicsList.filter((i, v) => i.id === formDetails.nextFormId)[0] : {};
          // If no next topic (last topic submitted), go back to the main topics list page
          if (!formDetails.nextFormId || isEmpty(nextOptionForm)) {
            setPopupVisible(false);
            navigate(`/?meetingId=${meeting.meetingId}&token=${params.token}&latitude=${params.latitude}&longitude=${params.longitude}`);
            return;
          }
          navigate(`/form${(location.search).replace(`&formId=${params.formId}`, `&formId=${formDetails.nextFormId}`).replace(`&crnId=${params.crnId}`, `&crnId=${params.crnId}`)}`, {
            state: {
              topicDetails: nextOptionForm,
              initialForm: false,
              topicsList: routeState.topicsList,
              userDetails: {
                ...routeState.userDetails,
              }
            }
          });
          setPopupVisible(false);
        }}
      >
        <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={leadQualified
              ? successIcon
              : failureIcon}
            alt={'head-logo'}
            style={{
              minWidth: leadQualified ? '100px' : '80px',
              height: leadQualified ? '100px' : '80px',
            }}
          />
          <label style={{textAlign:"center"}}>{formattedText}</label>
        </div>
      </CustomPopup>
    </>
  )
};

export default QuestionForm;